<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">Users</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p>
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group mcc-button-group--spaced">
                        <router-link :to="CONTEXT_PATH + '/usersgroups/userImport'">
                            <button class="mcc-button mcc-button--secondary mu-mr-05" id="importUserBtn" title="Import users">
                                <mcc-icon name="import" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Import users</span>
                            </button>
                        </router-link>
                        <router-link :to="CONTEXT_PATH + ''">
                            <button type="button" class="mcc-button mcc-button--success " v-if="federatedUserMode == 'true' && !isAdvancedSSO" @click="$refs.addNewUserDialog.show()" id="addUserBtn" title="You cannot add users because application is running in federated mode" dialog="addNewUserDialog" disabled="">
                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add user</span>
                            </button>
                            <button type="button" class="mcc-button mcc-button--success " @click="$refs.addNewUserDialog.show()" v-if="federatedUserMode == 'false' && !isAdvancedSSO" id="addUserBtn" title="Add user" dialog="addNewUserDialog">
                                <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add user</span>
                            </button>
                        </router-link>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb" >
            <ol class="mcc-breadcrumb">
                <li>Users & groups</li>
                <li>Users</li>
            </ol>
        </nav>
        

        
                

          
        <div class="mcc-row">
            <div class="mcc-col">
                <div style="position:relative">
                    <div v-if="!updateCall" class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                    <Drawer ref="customFilter" @reset-filter="resetForm" @apply-filter="submitFilterDialog($event)" title="User Filters">
                        <section>
                            <div class="mcc-row">
                                <div class="mcc-col">
                                    <form id="formIdd">
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05">
                                            <label for="username">Username</label>
                                            <input type="text" name="username" maxlength="255" id="username" :pattern="usernameFilterRegEx" ref="username" :value="filterUsername" @change="filterUsername = $event.target.value">
                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05">
                                            <label for="firstname">First name</label>
                                            <input type="text" name="firstname" maxlength="255" id="firstname" :pattern="nameRegex" ref="firstname" :value="filterFirstname" @change="filterFirstname = $event.target.value">
                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05">
                                            <label for="surname">Surname</label>
                                            <input type="text" name="surname" maxlength="255" id="surname" :pattern="nameRegex" ref="surname" :value="filterSurname" @change="filterSurname = $event.target.value">
                                        </div>
                                        <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-05">
                                            <label for="email">Email</label>
                                            <div class="mfc-input-group">
                                                <span>@</span>
                                                <input type="email" name="email" maxlength="255" id="email" ref="email" :value="filterEmail" @change="filterEmail = $event.target.value">
                                            </div>
                                        </div>
                                        <div class="mcc-segmented-buttons mcc-segmented-buttons--sm mu-mb-05 mfc-form-input-container">
                                            <fieldset class="mfc-fieldset">
                                                <legend class="mfc-label">
                                                    Out of office
                                                </legend>
                                                <div class="mcc-segmented-buttons__list ">
                                                    <input type="radio" name="view" value="yes" required id="outofOfficeY" @click="filterOutOfOffice = $event.target.value" :checked="filterOutOfOffice =='yes'">
                                                    <label class="mcc-segmented-buttons__button" for="outofOfficeY">
                                                        <span class="mcc-segmented-buttons__label">Yes</span>
                                                    </label>
                                                    <input type="radio" name="view" id="outofOfficeN" required value="no" @click="filterOutOfOffice = $event.target.value" :checked="filterOutOfOffice =='no'">
                                                    <label class="mcc-segmented-buttons__button" for="outofOfficeN">
                                                        <span class="mcc-segmented-buttons__label">No</span>
                                                    </label>
                                                    <input type="radio" name="view" id="outofOfficeA" required value=" " @click="filterOutOfOffice = $event.target.value" :checked="filterOutOfOffice ==' '">
                                                    <label class="mcc-segmented-buttons__button" for="outofOfficeA">
                                                        <span class="mcc-segmented-buttons__label">All</span>
                                                    </label>
                                                </div>
                                                <div class="mfc-invalid-feedback mfc-invalid-feedback--show"></div>
                                            </fieldset>
                                        </div>
                                        <div class="mt-2">
                                            <div class="mcc-segmented-buttons mcc-segmented-buttons--sm mu-mb-05 mfc-form-input-container">
                                                <fieldset class="mfc-fieldset">
                                                    <legend class="mfc-label">
                                                        Disabled
                                                    </legend>
                                                    <div class="mcc-segmented-buttons__list ">
                                                        <input type="radio" name="disabled" value="deleted" required id="disabledY" @click="filterDisabled = $event.target.value" :checked="filterDisabled =='deleted'">
                                                        <label class="mcc-segmented-buttons__button" for="disabledY">
                                                            <span class="mcc-segmented-buttons__label">Yes</span>
                                                        </label>
                                                        <input type="radio" name="disabled" id="disabledN" required value="active" @click="filterDisabled = $event.target.value" :checked="filterDisabled =='active'">
                                                        <label class="mcc-segmented-buttons__button" for="disabledN">
                                                            <span class="mcc-segmented-buttons__label">No</span>
                                                        </label>
                                                        <input type="radio" name="disabled" id="disabledA" required value=" " @click="filterDisabled = $event.target.value" :checked="filterDisabled ==' '">
                                                        <label class="mcc-segmented-buttons__button" for="disabledA">
                                                            <span class="mcc-segmented-buttons__label">All</span>
                                                        </label>
                                                    </div>
                                                    <div class="mfc-invalid-feedback mfc-invalid-feedback--show"></div>
                                                </fieldset>
                                            </div>
                                        </div>
                                        <div class="mfc-slim-select-wrapper mu-mb-03">
                                            <label for="groups" class="mu-mb-00">Groups</label>
                                            <select multiple @change="filterGroups = $event.target.value" ref="groups" name="groups" id="groups" block>
                                                <!-- <option v-for="(group,key) in groupsArr" :selected="filterGroups.indexOf(''+group.id) > -1" :key="key" :value="group.id">{{group.name}}</option> -->
                                            </select>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </section>
                    </Drawer>
                    <div class="mcc-row">
                        <div class="mcc-col">
                            <div class="mcc-card">
                                <div class="mcc-card__body">
                                    <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" v-if="federatedUserMode == 'true'" color="warning">
                                        <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                        <p>
                                            <strong>Warning!</strong>
                                            <br />You cannot add users because application is running in federated mode.
                                        </p>
                                    </mcc-alert>
                                    <div class="mu-d-flex mu-justify-content-end mu-pb-06">
                                        <button class="mcc-button mcc-button--outline mcc-button--sm" @click="$refs.customFilter.open()">
                                            <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                            <span class="mcc-button__label">Filters {{filterCount > 0 ? ` (${filterCount})` : '(2)'}}</span>
                                        </button>
                                    </div>
                                    <mcc-data-table ref="usersTable" id="usersTableId"></mcc-data-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--primary mcc-dialog--xs" ref="addNewUserDialog" id="addNewUserDialog">
            <form @submit.prevent="saveNewUser()" id="addNewUserDialog1" novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Add user</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.addNewUserDialog.close()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div class="mcc-row" v-show="!updateCallNewUser">
                            <div class="mcc-col colSpinner">
                                <div class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mcc-row" v-show="updateCallNewUser">
                            <div class="mcc-col">
                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                    <label for="newUsername">Username</label>
                                    <input type="text" id="newUsername" name="newUsername" required="" placeholder="Username" maxlength="255" ref="newUsername" :pattern="usernameRegex" @change="updateUsername($event)">
                                </div>
                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                    <label for="newUserfirstName">First name</label>
                                    <input type="text" id="newUserfirstName" name="newUserfirstName" required="" placeholder="First name" maxlength="255" :pattern="nameRegex" ref="newUserfirstName" @change="newUser.newUserfirstName = $event.target.value">

                                </div>
                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                    <label for="newUserSurName">Surname</label>
                                    <input type="text" id="newUserSurName" name="newUserSurName" required="" placeholder="Surname" maxlength="255" :pattern="nameRegex" ref="newUserSurName" @change="newUser.newUserSurName = $event.target.value">

                                </div>
                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                    <label for="newUserEmail">Email</label>
                                    <div class="mfc-input-group">
                                        <span>@</span>
                                        <input type="email" id="newUserEmail" required="" name="newUserEmail" maxlength="255" placeholder="Email" ref="newUserEmail" @change="updateEmail($event)">
                                    </div>
                                </div>
                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mu-mb-03">
                                    <label for="newUserPassword">Password</label>
                                    <input type="password" id="newUserPassword" name="newUserPassword" required="" maxlength="255" autocomplete="off" ref="newUserPassword" placeholder="Password" @change="newUser.newUserPassword = $event.target.value">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="$refs.addNewUserDialog.close()">Close</button>
                            <button type="submit" class="mcc-button mcc-button--primary">Save</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</template>

<script>
import UserAPI from "../../../services/UserAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Utils from "@/script_utils";
import Drawer from "../../common/Drawer.vue";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '../../../formvalid.js';

export default {
    name: "UserList",
    components: {
        Drawer
    },

    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["usersgroups.users.list"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            usernameFilterRegEx: constantMessages.PATTERNS["usernameFilter"],
            usernameRegex: constantMessages.PATTERNS["username"],
            usernameFilterRegEx: constantMessages.PATTERNS["usernameFilter"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            currentPageSize: 10,
            showHelpText: false,
            updateCall: true,
            tableObj: null,
            updateDialog: false,
            filterUsername: "",
            filterFirstname: "",
            filterSurname: "",
            filterEmail: "",
            filterOutOfOffice: " ",
            filterDisabled: "active",
            filterGroups: [],
            username: "",
            firstName: "",
            surname: "",
            email: "",
            outOfOffice: "",
            disabled: "active",
            groups: "",
            groupsArr: [],
            newUser: {},
            updateCallNewUser: true,
            passwordPolicy: "",
            federatedUserMode: "false",
            isAdvancedSSO: false,
            tableData: [],
            filterCount: 0,
            filterData: [],
            filterActive: false,

        }
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        if (this.$route.query.groupId) {
            let groupIdRef = this.$route.query.groupId;
            if (groupIdRef != "" && groupIdRef != null) {
                this.filterGroups.push(groupIdRef);
                this.groups = groupIdRef;
                this.disabled = " ";
                this.filterDisabled = " ";
            }
        }

        this.isAdvancedSSO = self.$store.getters.getIsAdvancedSSO;

        if (localStorage.getItem("UserList") === "userList") {

            let username = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_username");
            if (username != null) {
                this.username = username;
                this.filterUsername = username;
            }

            let firstname = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_firstname");
            if (firstname != null) {
                this.firstName = firstname;
                this.filterFirstname = firstname;
            }

            let surname = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_surname");
            if (surname != null) {
                this.surname = surname;
                this.filterSurname = surname;
            }

            let email = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_email");
            if (email != null) {
                this.email = email;
                this.filterEmail = email;
            }

            let outofoffice = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_outofOffice"
            );
            if (outofoffice != null) {
                this.outOfOffice = outofoffice;
                this.filterOutOfOffice = outofoffice;
            }

            let disabledStatus = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_disabled"
            );
            if (disabledStatus != null) {
                this.disabled = disabledStatus;
                this.filterDisabled = disabledStatus;
            }

            let groupsVal = localStorage.getItem(
                "DataTables_" + window.location.pathname + "_groups"
            );
            if (groupsVal != "" && groupsVal != null) {
                this.groups = groupsVal.split(",");
                this.filterGroups.push(groupsVal);
            }

            this.currentPageSize = parseInt(
                localStorage.getItem("userListPageSize")
            );
            localStorage.removeItem("ListPageSize");
            localStorage.removeItem("UserList");
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_username"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_firstname"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_surname"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_email"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_outofOffice"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_disabled"
            );
            localStorage.removeItem(
                "DataTables_" + window.location.pathname + "_groups"
            );
            this.filterCount = parseInt(localStorage.getItem("setFilterDataInLocalStorage"));
            localStorage.removeItem("setFilterDataInLocalStorage");
        }
        this.initUsersTable()
        if (this.$refs.usersTable.isReady) {
            this.initUsersTable();
        } else {
            this.$refs.usersTable.addEventListener("ready", function () {
                self.initUsersTable();
            });
        }
        this.selectInstanceEntities = new SlimSelect({
            select: '#groups',
            settings: {
                closeOnSelect: false,
            },
        })
        UserAPI.getNonDeletedGroups().then(response => {
            if (response != null) {
                let optionsArr = []
                let option;
                response.groupsArr.forEach(group => {
                    option = {
                        text: group.name,
                        value: group.id
                    }
                    optionsArr.push(option);
                })
                self.selectInstanceEntities.setData(optionsArr)
                self.groupsArr = response.groupsArr;
                self.federatedUserMode = response.federatedUserMode;
                self.passwordPolicy = response.passwordPolicy;
            }
        });
    },
    methods: {
        getFilterCount() {
            if (this.filterUsername != "")
                this.filterCount += 1;
            if (this.filterFirstname != "")
                this.filterCount += 1;
            if (this.filterSurname != "")
                this.filterCount += 1;
            if (this.filterEmail != "")
                this.filterCount += 1;
            if (this.filterOutOfOffice != "")
                this.filterCount += 1;
            if (this.filterDisabled != "")
                this.filterCount += 1;
            if (this.filterGroups != "")
                this.filterCount += 1;
        },
        showAddNewUserDialog() {
            let form = $("#addNewUserDialog mosaic-form")[0];
            if (form && form.ready) {
                form.addCustomValidation('newUserPassword', this.validatePassword);
            }
        },
        validatePassword(value, e) {
            if (value != "" && value.length <= 255 && this.passwordPolicy && this.passwordPolicy != "") {
                let invalidPassword = false;
                let policyErrorMessage = "Password";
                if (this.passwordPolicy.indexOf("length") != -1) {
                    let lengthPolicy = /length\(([^)]+)\)/.exec(this.passwordPolicy);
                    let length = lengthPolicy[1];
                    if (value.length < parseInt(length)) {
                        invalidPassword = true;
                    }
                    policyErrorMessage += policyErrorMessage.includes("must have") ? ", length(" + parseInt(length) + ")" : " must have at least length(" + parseInt(length) + ")";
                }
                if (this.passwordPolicy.indexOf("lowerCase") != -1) {
                    let lowercasePolicy = /lowerCase\(([^)]+)\)/.exec(this.passwordPolicy);
                    let noOfLowercase = lowercasePolicy[1];
                    if (value.match(/[a-z]/g) == null || value.match(/[a-z]/g).length < parseInt(noOfLowercase)) {
                        invalidPassword = true;
                    }
                    policyErrorMessage += policyErrorMessage.includes("must have") ? ", lower case(" + parseInt(noOfLowercase) + ")" : " must have at least lower case(" + parseInt(noOfLowercase) + ")";
                }
                if (this.passwordPolicy.indexOf("upperCase") != -1) {
                    let uppercasePolicy = /upperCase\(([^)]+)\)/.exec(this.passwordPolicy);
                    let noOfUppercase = uppercasePolicy[1];
                    if (value.match(/[A-Z]/g) == null || value.match(/[A-Z]/g).length < parseInt(noOfUppercase)) {
                        invalidPassword = true;
                    }
                    policyErrorMessage += policyErrorMessage.includes("must have") ? ", upper case(" + parseInt(noOfUppercase) + ")" : " must have at least upper case(" + parseInt(noOfUppercase) + ")";
                }
                if (this.passwordPolicy.indexOf("specialChars") != -1) {
                    let specialCharsPolicy = /specialChars\(([^)]+)\)/.exec(this.passwordPolicy);
                    let noOfSpeciaChars = specialCharsPolicy[1];
                    if (value.match(/[@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g) == null || value.match(/[@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g).length < parseInt(noOfSpeciaChars)) {
                        invalidPassword = true;
                    }
                    policyErrorMessage += policyErrorMessage.includes("must have") ? ", special character(" + parseInt(noOfSpeciaChars) + ")" : " must have at least special character(" + parseInt(noOfSpeciaChars) + ")";
                }
                if (this.passwordPolicy.indexOf("digits") != -1) {
                    let digitsPolicy = /digits\(([^)]+)\)/.exec(this.passwordPolicy);
                    let noOfDigits = digitsPolicy[1];
                    if (value.match(/\d/g) == null || value.match(/\d/g).length < parseInt(noOfDigits)) {
                        invalidPassword = true;
                    }
                    policyErrorMessage += policyErrorMessage.includes("must have") ? ", digit(" + parseInt(noOfDigits) + ")" : " must have at least digit(" + parseInt(noOfDigits) + ")";
                }

                this.passwordPolicy.split(" and").forEach(policy => {
                    if (policy.indexOf("regexPattern") != -1) {
                        let regexPatternPolicy = policy.substring(policy.indexOf("regexPattern") + 13, policy.length - 1);
                        let patt = new RegExp("^" + regexPatternPolicy + "$");

                        if (!patt.test(value)) {
                            invalidPassword = true;
                        }
                        policyErrorMessage += policyErrorMessage.includes("must have") ? " and " + policy : " must have " + policy;
                    }
                });

                if (this.passwordPolicy.indexOf("notUsername") != -1) {
                    if (this.$refs.newUsername && this.$refs.newUsername.value == value) {
                        invalidPassword = true;
                    }
                    policyErrorMessage += policyErrorMessage.includes("must have") ? " and should be different than username" : " should be different than username";
                }

                if (invalidPassword) {
                    return policyErrorMessage;
                }
            }
        },
        updateUsername(event) {
            if (event.target.value != "" && event.target.value.length > 255) {
                displayErrorMessage($(this.$refs.newUsername), constantMessages.MESSAGES["error.username.length"])
                this.$refs.newUsername.classList.add("ms-is-invalid")

            } else if (event.target.value == "") {
                displayErrorMessage($(this.$refs.newUsername), constantMessages.MESSAGES["error.username.required"])
                this.$refs.newUsername.classList.add("ms-is-invalid")
            } else {
                displayErrorMessage($(this.$refs.newUsername), constantMessages.MESSAGES["error.username.invalid"])
                this.$refs.newUsername.classList.add("ms-is-invalid")
            }
            this.newUser.newUsername = event.target.value;
        },
        updateEmail(event) {
            if (event.target.value != "" && event.target.value.length > 255) {
                displayErrorMessage($(this.$refs.newUserEmail), constantMessages.MESSAGES["error.email.length"])
                this.$refs.newUserEmail.classList.add("ms-is-invalid")
            } else if (event.target.value == "") {
                displayErrorMessage($(this.$refs.newUserEmail), constantMessages.MESSAGES["error.email.required"])
                this.$refs.newUserEmail.classList.add("ms-is-invalid")
            } else {
                displayErrorMessage($(this.$refs.newUserEmail), constantMessages.MESSAGES["error.email.invalid"])
                this.$refs.newUserEmail.classList.add("ms-is-invalid")
            }
            this.newUser.newUserEmail = event.target.value;
        },
        saveNewUser() {
            let form = $('#addNewUserDialog1')

            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            let self = this;
            self.updateCallNewUser = false;
            UserAPI.saveNewUser(
                self.newUser
            ).then(response => {
                self.updateCallNewUser = true;
                if (response) {
                    if (!response.error) {
                        EventBus.$emit("success-notification", {
                            msg: constantMessages.MESSAGES[response.message]
                        });
                        self.initUsersTable();
                        $("#addNewUserDialog")[0].close();
                    } else {
                        let validationError = false;
                        for (let k in response.messages) {
                            if (k == "username") {
                                displayErrorMessage($(self.$refs.newUsername), constantMessages.MESSAGES[response.messages[k]])
                                self.$refs.newUsername.classList.add("ms-is-invalid")
                                validationError = true;
                            }
                            if (k == "email") {
                                displayErrorMessage($(self.$refs.newUserEmail), constantMessages.MESSAGES[response.messages[k]])
                                self.$refs.newUserEmail.classList.add("ms-is-invalid")
                                validationError = true;
                            }
                        }
                        if (!validationError) {
                            EventBus.$emit("error-notification", {
                                msg: constantMessages.MESSAGES[response.message]
                            });
                        }
                    }
                }
            });
        },
        initUsersTable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("usersTableId"), {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No users found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize,
                fixedHeight: true,
                debounceTime: 1000,
                schema: {
                    properties: {
                        username: {
                            type: "string",
                            title: "Username",
                            sortable: true,
                            template: '<a class="name-link" data-id="{{id}}">{{username}}</a>',
                            columnSearch: false
                        },
                        firstName: {
                            type: "string",
                            title: "First name",
                            sortable: true,
                            columnSearch: false
                        },
                        surname: {
                            type: "string",
                            title: "Surname",
                            sortable: true,
                            columnSearch: false
                        },
                        isOutOfOffice: {
                            type: "string",
                            title: "Out of office",
                            sortable: false,
                            columnSearch: false
                        },
                        email: {
                            type: "string",
                            title: "Email",
                            sortable: true,
                            template: '<a href="mailto:{{email}}" class="email-link">{{email}}</a>',
                            columnSearch: false
                        },
                        isDisabled: {
                            type: "string",
                            title: "Disabled",
                            sortable: false,
                            columnSearch: false
                        },
                        groupCount: {
                            type: "string",
                            title: "Groups",
                            sortable: false,
                            columnSearch: false
                        },
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }

                        if (sortHeader == null) {
                            sortHeader = "username";
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc";
                        }
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&username=" +
                            encodeURI(self.username) +
                            "&firstname=" +
                            self.firstName +
                            "&surname=" +
                            self.surname +
                            "&email=" +
                            self.email +
                            "&isDisabled=" +
                            self.disabled.trim() +
                            "&groups=" +
                            self.groups +
                            "&outOfOffice=" +
                            self.outOfOffice;

                        return UserAPI.getUsers(queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                // Process data to mask "Unknown" surnames
                                responseData.data = result.data.map(user => {
                                    return {
                                        ...user,
                                        surname: user.surname === "Unknown" ? "" : user.surname
                                    };
                                });
                            }
                            self.updateCall = true;
                            self.responseData = responseData.data;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        showDialog() {
            this.updateDialog = true;
        },
        resetForm() {
            this.filterCount = 0;
            this.updateCall = false;
            this.username = "";
            this.firstName = "";
            this.surname = "";
            this.email = "";
            this.outOfOffice = " ";
            this.disabled = "active";
            this.groups = "";
            this.filterUsername = "";
            this.filterFirstname = "";
            this.filterSurname = "";
            this.filterEmail = "";
            this.filterOutOfOffice = " ";
            this.filterDisabled = "active";
            this.filterGroups = "";
            this.selectInstanceEntities.setSelected([])
            localStorage.clear();
            localStorage.setItem("showedBPMTour", "true");
            this.initUsersTable();
            this.updateTemplate();

        },
        closeDialog() {
            this.updateDialog = false;
        },
        showFilterDialog() {
            this.$refs.userFilterDialog.show();
        },
        submitFilterDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
                
            }
            this.filterCount = 0;
            this.getFilterCount();
            this.username = this.filterUsername;
            this.firstName = this.filterFirstname;
            this.surname = this.filterSurname;
            this.email = this.filterEmail;
            this.outOfOffice = this.filterOutOfOffice;
            this.disabled = this.filterDisabled;
            this.groups = this.selectInstanceEntities.getSelected();
            this.initUsersTable();
            this.updateTemplate();
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        updateTemplate() {
            let self = this;
            this.$refs.usersTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            self.setFilterDataInLocalStorage();
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/usersgroups/users/" + reference.trim()
                            );
                        }
                    });
                });

        },
        setFilterDataInLocalStorage() {
            localStorage.setItem("userListPageSize", this.tableObj.tableContext.store.state.pageSize);
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_username",
                this.username
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_firstname",
                this.firstName
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_surname",
                this.surname
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_email",
                this.email
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_outofOffice",
                this.outOfOffice
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_disabled",
                this.disabled
            );
            localStorage.setItem(
                "DataTables_" + window.location.pathname + "_groups",
                this.groups
            );
            localStorage.setItem("applicationListFilterCount", this.filterCount);
        },

    },
}
</script>
